import { Token } from '@app/types/token';
import { create } from 'zustand';
import { Chain } from '@thirdweb-dev/chains';
import { Pool } from '@app/types/pool';

interface RouterIntentState {
  readonly sourceNetwork: Chain | null;
  readonly sourceToken: Token | null;
  readonly sourceAmount: string;
  readonly targetPool: Pool | null;
  readonly targetChainId: number | null;
  actions: {
    setSourceNetwork: (chain: Chain) => void;
    setSourceToken: (token: Token | null) => void;
    setSourceAmount: (token: string) => void;
    setTargetPool: (pool: Pool) => void;
    setTargetChainId: (chaimId: number) => void;
  };
}

export const useRouterIntentState = create<RouterIntentState>(setState => ({
  sourceNetwork: null,
  sourceToken: null,
  sourceAmount: '',
  targetPool: null,
  targetChainId: null,
  actions: {
    setSourceNetwork: (chain: Chain) => setState({ sourceNetwork: chain }),
    setSourceToken: (token: Token | null) => setState({ sourceToken: token }),
    setSourceAmount: (amount: string) => setState({ sourceAmount: amount }),
    setTargetPool: (pool: Pool) => setState({ targetPool: pool }),
    setTargetChainId: (chainId: number) => setState({ targetChainId: chainId })
  }
}));
